import { createFileRoute } from '@tanstack/react-router'
import { AlertRuleFormPage } from '../../../features/alerts/AlertRuleFormPage'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/alerts/$id/edit')({
  component: AlertRuleEditRoute,
})

function AlertRuleEditRoute() {
  const { id } = Route.useParams()
  return <AlertRuleFormPage ruleId={id} />
}
